import { render, staticRenderFns } from "./recent-products.vue?vue&type=template&id=1895f6e4&"
import script from "./recent-products.vue?vue&type=script&lang=js&"
export * from "./recent-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports